import { render, staticRenderFns } from "./PartialItemsStatusChangeSundryOrdersPopUp.vue?vue&type=template&id=864c6800&scoped=true&"
import script from "./PartialItemsStatusChangeSundryOrdersPopUp.vue?vue&type=script&lang=js&"
export * from "./PartialItemsStatusChangeSundryOrdersPopUp.vue?vue&type=script&lang=js&"
import style0 from "./PartialItemsStatusChangeSundryOrdersPopUp.vue?vue&type=style&index=0&id=864c6800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864c6800",
  null
  
)

export default component.exports